import { apiRequestToken } from '../Utilidades/apiRequest';
import { ComunicadosProps, BusquedaComunicadoProps, FavoritosImportantesProps, FavoritosImportantesDeleteProps, FavoritosImportantesDeleteAllProps } from '../interfaces/comunicadosInterfaces';


export const getComunicadosHome = async () => {
    return apiRequestToken({
        endpoint: 'comunicadoshome',
        token: false,
        method: 'GET',
    })
};
export const getComunicadoHome = async (id: string) => {
    return apiRequestToken({
        endpoint: `comunicadoshome/${id}`,
        token: false,
        method: 'GET',
    })
};
export const getComunicados = async () => {
    return apiRequestToken({
        endpoint: 'comunicados',
        method: 'GET',
    })
};
export const getComunicado = async (id: string) => {
    return apiRequestToken({
        endpoint: `comunicados/${id}`,
        method: 'GET',
    })
};
export const postComunicado = async (comuicado: ComunicadosProps) => {
    return apiRequestToken({
        endpoint: 'comunicados/',
        body: comuicado,
        method: 'POST',
    })
};
export const deleteComunicados = async (id: number) => {
    return apiRequestToken({
        endpoint: `comunicados/${id}`,
        method: 'DELETE',
    })
};
export const postBusquedaComunicado = async (filtros: BusquedaComunicadoProps) => {
    return apiRequestToken({
        endpoint: 'comunicadospalabrasclave',
        body: filtros,
        method: 'POST',
    })
};
export const postFavoritoImportante = async (favoritosImportantes: FavoritosImportantesProps) => {
    return apiRequestToken({
        endpoint: 'comunicadosfavoritos',
        body: favoritosImportantes,
        method: 'POST',
    })
};
export const getComunicadoFavoritos = async (id: string) => {
    return apiRequestToken({
        endpoint: `comunicadosfavoritos?idu_google=${id}`,
        method: 'GET',
    })
};
//Modificacion: Marca de Inicio WII C-24-1229-24
export const deleteFavorito = async (favoritosImportantes: FavoritosImportantesDeleteProps) => {
    return apiRequestToken({
        endpoint: 'comunicadosfavoritosdel',
        body: favoritosImportantes,
        method: 'POST',
    })
};
export const deleteAllFavorito = async (favoritosImportantes: FavoritosImportantesDeleteAllProps) => {
    return apiRequestToken({
        endpoint: 'comunicadosfavoritosdel',
        body: favoritosImportantes,
        method: 'POST',
    })
};
//Modificacion: Marca de Fin WII C-24-1229-24